<template>
    <div class="with-inline-website-assistant">
        <website-assistant
            :force-open="forceOpenPopup"
            :inline="true"
            from="jinglebox"
            :title="assistantTitle"
            :subtitle="assistantSubtitle"
            :text="assistantText"
        ></website-assistant>
        <section v-if="initialized">
            <input type="hidden" ref="gclid" id="gclid_field" name="gclid_field" value="">
            <div class="pad">
                <div class="wrap">
                    <div class="sounds-picker">
                        <div class="search">
                            <div class="search-container" :class="{'with-geo-field':showForceGeoFields}">
                                <div>
                                    <input type="text" :placeholder="window.t('jinglebox_searchbar')" v-model="search" @keyup.enter="addSearchTag">
                                    <a href="#" :class="['filter-toggle', {'filter-mobile-visible':filterMobileVisible}]" @click.prevent="toggleFilterMobile">
                                        <img src="/images/filter.svg">
                                    </a>
                                </div>
                                <div v-if="showForceGeoFields" class="geo-wrapper">
                                    <input type="text" placeholder="Search for cities" v-model="geoSearch" @input="fetchGeo" @focus="showGeoResults = true" @blur="delayedBlur">
                                    <div v-if="(geoResults || selectedGeoLocation) && showGeoResults" class="results">
                                        <div v-if="selectedGeoLocation" @click.prevent="resetGeoResult()" class="result">
                                            &times; Reset
                                        </div>
                                        <div v-for="geoResult in geoResults" :key="geoResult.id" @click.prevent="selectGeoResult(geoResult)" class="result">
                                            {{ geoResult.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tags">
                            <ul v-if="searchTags.length || selectedGenres.length || selectedTempos.length || selectedFormats.length">
                                <li class="tag" v-for="(searchTag, searchTagIndex) in searchTags" :key="'selected-genre-' + searchTagIndex"><a href="#" @click.prevent="removeSearchTag(searchTagIndex)">{{ searchTag }}</a></li>
                                <li class="tag" v-for="(selectedFormat, selectedFormatIndex) in selectedFormats" :key="'selected-format-' + selectedFormatIndex"><a href="#" @click.prevent="toggleFormat(selectedFormat)">{{ selectedFormat.name }}</a></li>
                                <li class="tag" v-for="(selectedTempo, selectedTempoIndex) in selectedTempos" :key="'selected-tempo-' + selectedTempoIndex"><a href="#" @click.prevent="toggleTempo(selectedTempo)">{{ selectedTempo.name }}</a></li>
                                <li class="tag" v-for="(selectedGenre, selectedGenreIndex) in selectedGenres" :key="'selected-genre-' + selectedGenreIndex"><a href="#" @click.prevent="toggleGenre(selectedGenre)">{{ selectedGenre.name }}</a></li>
                                <li><a href="#" @click.prevent="resetFilter" class="reset">{{ window.t('general_reset_filter') }}</a></li>
                            </ul>
                        </div>
                        <div :class="['filter', {'filter-mobile-visible':filterMobileVisible}]">
                            <div class="filter-sticky">
                                <ul class="main" v-if="genres.length || tempos.length || formats.length">
                                    <li v-if="formats.length"><a href="#" :class="{on: selectedFilter == 'format'}" @click.prevent="selectFilter('format')">Format</a></li>
                                    <li v-if="tempos.length"><a href="#" :class="{on: selectedFilter == 'tempo'}" @click.prevent="selectFilter('tempo')">Tempo</a></li>
                                    <li v-if="genres.length"><a href="#" :class="{on: selectedFilter == 'genre'}" @click.prevent="selectFilter('genre')">Genre</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'format'">
                                    <li v-for="format in formats" :key="'format-' + format.id"><a href="#" @click.prevent="toggleFormat(format)" :class="{on: isFormatActive(format)}">{{ format.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'tempo'">
                                    <li v-for="tempo in tempos" :key="'tempo-' + tempo.id"><a href="#" @click.prevent="toggleTempo(tempo)" :class="{on: isTempoActive(tempo)}">{{ tempo.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'genre'">
                                    <li v-for="genre in genres" :key="'genre-' + genre.id"><a href="#" @click.prevent="toggleGenre(genre)" :class="{on: isGenreActive(genre)}">{{ genre.name }}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div ref="sounds" class="sounds">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="th-label hide-l"></th>
                                        <th></th>
                                        <th @click.prevent="toggleSort('title')" :class="getColumnHeaderClasses('title')">
                                            <span>Title</span>
                                        </th>
                                        <th @click.prevent="toggleSort('genre')" :class="getColumnHeaderClasses('genre')" class="hide-m">
                                            <span>Genre</span>
                                        </th>
                                        <th @click.prevent="toggleSort('station')" :class="getColumnHeaderClasses('station')" class="hide-s">
                                            <span>Station</span>
                                        </th>
                                        <th @click.prevent="toggleSort('tempo')" :class="getColumnHeaderClasses('tempo')" class="hide-m">
                                            <span>Tempo</span>
                                        </th>
                                        <th class="hide-m">
                                            <span style="cursor: initial !important;">Format</span>
                                        </th>
                                        <th style="min-width:90px;">
                                        </th>
                                        <th @click.prevent="toggleSort('length')" :class="getColumnHeaderClasses('length')" class="hide-m">
                                            <span>Length</span>
                                        </th>
                                        <th></th>
                                        <th class=""></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="results.length">
                                        <template v-for="(result, resultIndex) in results">
                                            <tr :class="[result.children.length ? 'child-row top-row' : '', result.children.length && !jingleExpanded(result) ? 'bottom-row' : '']" :key="'result-row-' + resultIndex + '-jingle-' + result.id">
                                                <td class="hide-l"><div class="label" v-if="result.new">New</div></td>
                                                <td class="with-play-button"><play-button :player-id="'jinglebox-results-' + result.id" :file-id="result.id" :description="result.name"></play-button></td>
                                                <td>{{ result.name }}</td>
                                                <td class="hide-m">{{ result.genre }}</td>
                                                <td class="hide-s">{{ result.station }}</td>
                                                <td class="hide-m">{{ result.tempo }}</td>
                                                <td class="hide-m">{{ result.formats }}</td>
                                                <td class="waveform-td"><player :player-id="'jinglebox-results-' + result.id" :file-id="result.id" wave-form-image-template="frontend_jinglebox" :totalTime="result.duration"></player></td>
                                                <td class="hide-m">{{ result.duration_string }}</td>
                                                <td><a href="#" :class="['favorite', {on: jingleInSelection(result) }]" @click.prevent="toggleSelectionItem(result.id)"></a></td>
                                                <td class="with-toggle"><a href="#" v-if="result.children.length" :class="['expand-children', {on: jingleExpanded(result) }]" @click.prevent="toggleJingleExpand(result)"></a></td>
                                            </tr>
                                            <template v-if="result.children.length && jingleExpanded(result)">
                                                <tr v-for="(child, childIndex) in result.children" :key="'result-row-' + resultIndex + '-jingle-' + result.id + '-child-' + childIndex + '-child-' + child.id" class="child-row" :class="childIndex == result.children.length - 1 ? 'bottom-row' : ''">
                                                    <td class="hide-l"><div class="label" v-if="child.new">New</div></td>
                                                    <td class="with-play-button"><play-button :player-id="'jinglebox-results-' + result.id + '-child-' + child.id" :file-id="child.id" :description="child.name"></play-button></td>
                                                    <td>{{ child.name }}</td>
                                                    <td class="hide-m">{{ child.genre }}</td>
                                                    <td class="hide-m">{{ child.station }}</td>
                                                    <td class="hide-m">{{ child.tempo }}</td>
                                                    <td class="hide-m">{{ child.formats }}</td>
                                                    <td class="waveform-td"><player :player-id="'jinglebox-results-' + result.id + '-child-' + child.id" :file-id="child.id" wave-form-image-template="frontend_jinglebox" :totalTime="child.duration"></player></td>
                                                    <td class="hide-m">{{ child.duration_string }}</td>
                                                    <td><a href="#" :class="['favorite', {on: jingleInSelection(child) }]" @click.prevent="toggleSelectionItem(child.id)"></a></td>
                                                    <td></td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                    <tr v-else>
                                        <td colspan="10">{{ window.t('general_no_results') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pager" v-if="totalPages > 1">
                                <a href="#" v-if="currentPage > 1" @click.prevent="goToPrevPage">
                                	<span class="full">{{ window.t('general_previous') }}</span>
                                	<span class="compact">&lt;</span>
                                </a>
                                <span class="current-page">
                                    <input type="text" :value="currentPage" disabled="disabled">
                                    {{ window.t('general_step', true) }} {{ totalPages }}
                                </span>
                                <a href="#" v-if="currentPage < totalPages" @click.prevent="goToNextPage">
                                	<span class="full">{{ window.t('general_next') }}</span>
                                	<span class="compact">&gt;</span>
                                </a>
                            </div>
                        </div>
                        <div class="selection">
                            <div class="selection-sticky">
                                <div class="card">
                                    <div class="level w100 mb1 mt-1">
                                        <h5 class="h5">{{ window.t('jinglebox_your_selection') }}</h5>
                                        <a v-if="selection.length" href="#" class="push-to-end" @click.prevent="removeAllSelectionItems"><img src="/images/trash.svg" alt="Clear selection" class="trash"></a>
                                    </div>
                                    <ul class="sounds-list w100" v-if="selection.length">
                                        <li class="sound" v-for="(selectionItem, selectionItemIndex) in selection" :key="'selection-' + selectionItemIndex + '-jingle-' + selectionItem.id">
                                            <player :file-id="selectionItem.id"></player>
                                            <div class="title">{{ selectionItem.name }}</div>
                                            <a href="#" class="remove" @click.prevent="toggleSelectionItem(selectionItem.id)"><img src="/images/remove-sound.svg" alt="Remove sound"></a>
                                        </li>
                                    </ul>
                                    <div class="empty-selection" v-else>
                                        {{ window.t('jinglebox_selection_body') }}
                                    </div>
                                    <div class="btn-box" v-if="selection.length">
                                        <a href="#" class="btn" @click.prevent="toggleCheckout">{{ window.t('jinglebox_save') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selection.length" class="download-selection-mobile">
                            <a href="#" class="btn" @click.prevent="toggleCheckout">{{ window.t('jinglebox_save') }} ({{ selection.length }})</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="checkoutVisible">
			<div class="bg" @click.prevent="toggleCheckout"></div>
			<div class="panel-scroller">
				<div class="panel">
					<a href="#" class="close" @click.prevent="toggleCheckout"></a>
					<form class="form">
						<div class="modal-head">
							<h2 class="h2">Pure Jinglebox</h2>
							<h3 class="h2 black" v-html="checkoutStepDataCol('title')" v-if="!completedOrderId"></h3>
							<!-- <h3 class="h2 black" v-else>{{ window.t('jinglebox_your_download') }}</h3> -->
							<div class="txt">
                                <span v-html="window.t('jinglebox_header')"></span>

                                <!-- A few quick steps to a package you love!<br>
                                You choose your jingles, and we add a custom audio logo and a custom vocal sound.<br>
                                <br>
                                Need assistance? Call <a href="tel://31356217599">+31 (0)35 6217599</a> or email <a href="mailto:info@purejingles.com">info@purejingles.com</a> -->
	                        </div>
						</div>
						<div class="modal-body">
							<!-- <div class="step text-centered" v-if="completedOrderId">
	                            <img src="/images/jinglebox-order-complete.svg"><br>
	                            <br>
                                <a href="#" @click.prevent="downloadOrderZip" v-html="window.t('jinglebox_download_confirm')"></a>
	                        </div> -->
							<div class="step" v-if="checkoutStep == 1">
								<div class="row">
									<div class="col c5">
										<div class="fields">
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_first_name')+'*'" v-model="checkoutData.first_name">
											</div>
                                            <div class="field w100">
												<input type="text" :placeholder="window.t('form_your_last_name')+'*'" v-model="checkoutData.last_name">
											</div>
											<div class="field w100">
												<input type="email" :placeholder="window.t('form_your_email')+'*'" v-model="checkoutData.email">
											</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_phone')" v-model="checkoutData.phone">
											</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_website')" v-model="checkoutData.radio_station_website">
											</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_station')" v-model="checkoutData.radio_station">
											</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_slogan')" v-model="checkoutData.radio_station_slogan">
											</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_area')" v-model="checkoutData.broadcast_area">
											</div>
										</div>
									</div>
									<div class="col c6 o1">
										<h3 class="h5 black mb1">{{ window.t('jinglebox_selection') }}</h3>
										<div class="selected-items txt">
											<span v-for="selectionItem in selection" :key="'checkout-selection-' + selectionItem.id">{{ selectionItem.name }}<br></span>
										</div>
									</div>
								</div>
							</div>
							<div class="step" v-else-if="checkoutStep == 2">
								<div class="row">
									<div class="col c5">
										<div class="fields">
											<div class="field w100">
                                                {{ window.t('form_question_logo') }}
												<!-- Do you currently have an audio logo? -->
												<div class="inline-radios">
													<label>
														<input type="radio" :value="1" v-model="checkoutData.has_audio_logo"> {{ window.t('general_yes') }}
													</label>
													<label>
														<input type="radio" :value="0" v-model="checkoutData.has_audio_logo"> {{ window.t('general_no') }}
													</label>
												</div>
											</div>
											<div class="field w100" v-if="checkoutData.has_audio_logo">
                                                {{ window.t('form_question_free_of_rights') }}
												<div class="inline-radios">
													<label>
														<input type="radio" :value="1" v-model="checkoutData.audio_logo_is_free_of_rights"> {{ window.t('general_yes') }}
													</label>
													<label>
														<input type="radio" :value="0" v-model="checkoutData.audio_logo_is_free_of_rights"> {{ window.t('general_no') }}
													</label>
												</div>
											</div>
										</div>
									</div>
									<div class="col c6 o1" v-if="checkoutData.has_audio_logo">
	                                    <audio-uploader :value.sync="checkoutData.audio_file" :upload-text="window.t('general_upload_logo')"></audio-uploader>
									</div>
								</div>
							</div>
							<div class="step" v-else-if="checkoutStep == 3">
								<div class="row">
									<div class="col c5">
										<div class="fields">
											<div class="field w100">
                                                {{ window.t('jinglebox_question_production_style') }}
												<div class="inline-radios">
													<label>
														<input type="radio" value="Soft" v-model="checkoutData.preferred_style"> Soft
													</label>
													<label>
														<input type="radio" value="Medium" v-model="checkoutData.preferred_style"> Medium
													</label>
													<label>
														<input type="radio" value="Energetic" v-model="checkoutData.preferred_style"> Energetic
													</label>
												</div>
											</div>
											<div class="field w100">
                                                {{ window.t('jinglebox_question_voice_style') }}
												<div class="inline-radios">
													<label>
														<input type="radio" value="Sung" v-model="checkoutData.preferred_vocals"> Sung
													</label>
													<label>
														<input type="radio" value="Spoken" v-model="checkoutData.preferred_vocals"> Spoken
													</label>
													<label>
														<input type="radio" value="Sung + spoken" v-model="checkoutData.preferred_vocals"> Sung + spoken
													</label>
												</div>
											</div>
										</div>
									</div>
									<div class="col c6 o1">
										<div class="recorder-box">
											<div class="txt">
                                                {{ window.t('jinglebox_upload_pronunciation') }}
											</div>
											<div class="options">
	                                            <audio-uploader class="option" :value.sync="checkoutData.pronunciation_file" compact></audio-uploader>
	                                            <audio-recorder class="option" :value.sync="checkoutData.pronunciation_recording"></audio-recorder>
											</div>
										</div>
										<br>
										<div class="recorder-box">
											<div class="txt">
                                                {{ window.t('jinglebox_upload_audio') }}
											</div>
											<div class="options">
	                                            <audio-uploader class="option" :value.sync="checkoutData.inspiration_file" compact></audio-uploader>
	                                            <audio-recorder class="option" :value.sync="checkoutData.inspiration_recording"></audio-recorder>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="step" v-else-if="checkoutStep == 4">
								<h3 class="h5 black mb1">{{ window.t('form_check') }}</h3>
								<div v-html="window.t('form_check_body')" class="txt">
								</div>
								<br>
								<br>
								<div class="row">
									<div class="col c4">
										<h4 class="h6 pink mb05">{{ window.t('general_general') }}</h4>
										<div class="txt">
											{{ checkoutData.first_name }} {{ checkoutData.last_name }}<br>
											{{ checkoutData.email }}<br>
											{{ checkoutData.phone }}<br>
											<template v-if="checkoutData.radio_station_website">{{ checkoutData.radio_station_website }}<br></template>
											<template v-if="checkoutData.radio_station">{{ checkoutData.radio_station }}<br></template>
											<template v-if="checkoutData.radio_station_slogan">{{ checkoutData.radio_station_slogan }}<br></template>
											<template v-if="checkoutData.broadcast_area">{{ checkoutData.broadcast_area }}<br></template>
										</div>
									</div>
									<div class="col c4">
										<h4 class="h6 pink mb05">{{ window.t('jinglebox_selection') }}</h4>
										<div class="txt">
                                            {{ window.t('jinglebox_selected', false, {'selectedAmount': selection.length }) }}
											<!-- {{ selection.length }} Jingles selected -->
										</div>
									</div>
									<div class="col c4">
										<h4 class="h6 pink mb05">{{ window.t('general_audio_logo') }}</h4>
										<div class="txt">
											{{ checkoutData.has_audio_logo ? window.t('general_existing_logo') : window.t('general_non_existing_logo') }}<br>
											{{ checkoutData.has_audio_logo ? (checkoutData.audio_logo_is_free_of_rights ? window.t('general_free_of_rights') : window.t('general_not_free_of_rights')) : '' }}<br>
	                                        <play-button  player-id="jinglebox-checkout-audio-logo" v-if="checkoutData.audio_file" :use-label="window.t('general_audio_logo_example')" class-name="" description="Jinglebox - Audio logo"></play-button>
	                                        <player v-if="checkoutData.audio_file" player-id="jinglebox-checkout-audio-logo" :file-url="'/files/' + checkoutData.audio_file"></player>
										</div>
									</div>
									<div class="col c4">
										<h4 class="h6 pink mb05">{{ window.t('general_production') }}</h4>
										<div class="txt">
											{{ checkoutData.preferred_style }} style<br>
											{{ checkoutData.preferred_vocals }} vocals<br>
	                                        <play-button  player-id="jinglebox-checkout-pronunciation-file" v-if="checkoutData.pronunciation_file" use-label="Pronunciation example" class-name="" description="Jinglebox - Pronunciation file"></play-button>
	                                        <player v-if="checkoutData.pronunciation_file" player-id="jinglebox-checkout-pronunciation-file" :file-url="'/files/' + checkoutData.pronunciation_file"></player>
	                                        <a href="#" v-if="checkoutData.pronunciation_recording" @click.prevent="pronunciationRecordingPlay">Pronunciation example (Recording)</a>
										</div>
									</div>
								</div>
                                <div class="row">
                                    <div class="col c12">
                                        <br>
                                        <div class="checkbox-wrap">
                                            <input v-model="checkoutData.consent" :value="true" data-hj-allow class="brown" type="checkbox" id="terms" name="terms">
                                            <label class="checkbox-label" for="terms">{{ window.t('form_consent_body') }}</label>
                                        </div>
                                    </div>
                                </div>
							</div>
						</div>
						<div class="modal-foot">
							<a href="#" :class="['btn', 'w180', {hidden: checkoutStep == 1}]" @click.prevent="checkoutPrev" v-if="!completedOrderId">Prev<span class="full">ious step</span></a>
							<div class="progress" v-if="!completedOrderId">
								<span class="full">Step</span> {{ checkoutStep }} of {{ maxStep }}
							</div>
	                        <div v-else>&nbsp;</div>
							<a href="#" v-if="!completedOrderId" :class="['btn', 'w180', {disabled: !nextStepAvailable}]" @click.prevent="checkoutNext" v-html="(checkoutStep == maxStep ? 'Confirm' : 'Next<span class=\'full\'>&nbsp;step</span>')"></a>
						</div>
					</form>
				</div>
			</div>
		</section>
    </div>
</template>


<script>

  export default {
        props: {
            forceOpenPopup: {
                type: Boolean,
                default: false,
            },
            showForceGeoFields: {
                type: Boolean,
                default: false,
            },
            itemsPerPage: {
                type: Number,
                default: 25,
            },
            defaultLanguage: {
                type: String,
                default: 'en',
            },
            language: {
                type: String,
                default: 'en',
            },
            basePath: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
            assistantTitle: {
                type: String,
                default: null,
            },
            assistantSubtitle: {
                type: String,
                default: null,
            },
            assistantText: {
                type: String,
                default: null,
            },
            preSelectedFilter: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                window,
                initialized: false,
                search: '',
                searchTags: [],
                genres: [],
                tempos: [],
                formats: [],
                selectedGenres: [],
                selectedTempos: [],
                selectedFormats: [],
                geoResults: [],
                showGeoResults: false,
                geoSearch: '',
                fetchGeo: _.debounce(this._fetchGeo, 500),
                selectedGeoLocation: null, // city id only, province and country are related
                sort: null,
                sortDirection: 'asc',
                selection: [],
                results: [],
                selectedFilter: null,
                currentPage: 1,
                totalItems: 0,
                totalPages: 0,
                expandedJingles: [],
                watchRoute: true,
                requestPath: true,
                checkoutVisible: false,
                checkoutStep: 1,
                checkoutStepData: {
                    1: {
                        title: 'General',
                    },
                    2: {
                        title: 'Audio logo',
                    },
                    3: {
                        title: 'Production',
                    },
                    4: {
                        title: 'Overview',
                    },
                },
                checkoutData: {},
                completedOrderId: null,
                filterMobileVisible: false,
            }
        },
        watch: {
            watchValue(newValue,oldValue) {
                if (this.initialized) {
                    this.goToPath();
                }
            },
            '$route' (to, from) {
				if (to.path != from.path && this.watchRoute && this.initialized) {
                    this.initialized = false;
					this.fetchData(1);
				}
			},
        },
        methods: {
            async _fetchGeo() {
                try {
                    const response = await axios.post('/geo/search', {
                        search: this.geoSearch
                    });

                    if (response.data.hasOwnProperty('cities')) {
                        this.geoResults = response.data.cities;
                    }
                } catch(exc) {
                    console.log(exc);
                }
            },
            selectGeoResult(geoResult) {
                this.selectedGeoLocation = geoResult.id;
                this.geoSearch = geoResult.cityName;
                this.showGeoResults = false;

                this.fetchData();
            },
            resetGeoResult() {
                this.selectedGeoLocation = null;
                this.geoSearch = '';
                this.showGeoResults = false;

                this.fetchData();
            },
            delayedBlur() {
                setTimeout(() => {
                    this.showGeoResults = false;
                }, 250);
            },
            selectFilter(filter){
                if (this.selectedFilter != filter) {
                    this.selectedFilter = filter;
                }
            },
            addSearchTag() {
                let searchTag = this.search.trim();

                if (searchTag == '') {
                    return;
                }

                if (!this.searchTags.includes(searchTag)) {
                    this.searchTags.push(searchTag);
                }

                this.search = '';
            },
            removeSearchTag(searchTag) {
                this.searchTags.splice(this.searchTags.indexOf(searchTag), 1);
            },
            pronunciationRecordingPlay() {
                if (this.checkoutData.pronunciation_recording) {
                    const audioUrl = URL.createObjectURL(this.checkoutData.pronunciation_recording);
                    const audio = new Audio(audioUrl);
                    audio.play();
                }

                return false;
            },
            initCheckoutData() {
                this.checkoutData = {
                    jinglebox_url: this.url,
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    radio_station: '',
                    radio_station_website: '',
                    radio_station_slogan: '',
                    broadcast_area: '',
                    has_audio_logo: null,
                    audio_logo_is_free_of_rights: null,
                    audio_file: '',
                    preferred_style: '',
                    preferred_vocals: '',
                    pronunciation_file: '',
                    pronunciation_recording: '',
                    inspiration_file: '',
                    inspiration_recording: '',
                    consent: false,
                };
            },
            toggleCheckout() {
                this.checkoutVisible = !this.checkoutVisible;
                $html.toggleClass('modal-visible');

                if (!this.checkoutVisible) {
                    this.checkoutStep = 1;
                    this.completedOrderId = null;
                }
            },
            checkoutStepDataCol(col) {
                if (this.checkoutStepData[this.checkoutStep][col]) {
                    return this.checkoutStepData[this.checkoutStep][col];
                }

                return '';
            },
            checkoutPrev() {
                if (this.checkoutStep > 1) {
                    this.checkoutStep--;
                }
            },
            async checkoutNext() {
                if (this.nextStepAvailable) {
                    if (this.checkoutStep < this.maxStep) {
                        this.checkoutStep++;
                    } else {
                        if (!await this.submit()) {
                            alert(window.t('form_error'));
                        }
                    }
                }
            },
            async submit() {
                let validated = false;

                const config = {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                };

                const formData = new FormData();
                const checkoutDataProperties = Object.getOwnPropertyNames(this.checkoutData);

                if (this.$refs.gclid) {
                    formData.append('gclid', this.$refs.gclid.value);
                }

                for (var k in checkoutDataProperties) {
                    if (checkoutDataProperties[k] == 'audio_logo_is_free_of_rights' && this.checkoutData.has_audio_logo == 0) {
                        formData.append(checkoutDataProperties[k], 0);
                        continue;
                    }

                    let useValue = this.checkoutData[checkoutDataProperties[k]];

                    if (k == 'pronunciation_recording' || k == 'inspiration_recording') {
                        if (this.checkoutData[checkoutDataProperties[k]]) {
                            let extension = this.checkoutData[checkoutDataProperties[k]].type.split('/')[1];
                            useValue = new File([this.checkoutData[checkoutDataProperties[k]]], `${Date.now()}.${extension}`, {
                                type: this.checkoutData[checkoutDataProperties[k]].type,
                            });
                        }
                    }

                    formData.append(checkoutDataProperties[k], useValue);
                }

                formData.append('referrer', location.toString());

                await axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/jinglebox/validate-checkout', formData, config)
                    .then((response) => {

                        if (response.data.hasOwnProperty('redirect_url')) {
                            validated = true;
                            this.checkoutVisible = false;
                            document.location = response.data.redirect_url;
                        }
                    })
                    .catch(() => {

                    });

                return validated;
            },
            goToPath: async function (fetchData = true) {
                // console.log('goToPath start: ' + this.selection.length);
                this.watchRoute = false;

                let goToPath = '/' + this.basePath;

                if (this.selectedGenres.length || this.selectedTempos.length || this.selectedFormats.length  || this.selection.length || this.searchTags.length || this.sort != null) {
                    const seperator = '||-||';
                    const delimitor = '||||';

                    let string = 'search=';

                    for (let s in this.searchTags) {
                        string += this.searchTags[s] + (s < this.searchTags.length -1 ? delimitor : '');
                    }

                    string += seperator + 'genres=';

                    for (let g in this.selectedGenres) {
                        string += this.selectedGenres[g].id + (g < this.selectedGenres.length -1 ? delimitor : '');
                    }

                    string += seperator + 'tempos=';

                    for (let t in this.selectedTempos) {
                        string += this.selectedTempos[t].id + (t < this.selectedTempos.length - 1 ? delimitor : '');
                    }

                    string += seperator + 'formats=';

                    for (let t in this.selectedFormats) {
                        string += this.selectedFormats[t].id + (t < this.selectedFormats.length - 1 ? delimitor : '');
                    }

                    string += seperator + 'selection=';

                    for (let s in this.selection) {
                        string += this.selection[s].id + (s < this.selection.length - 1 ? delimitor : '');
                    }

                    string += seperator + 'sort=' + (this.sort ? this.sort : '');

                    string += seperator + 'sortDirection=' + this.sortDirection;
                    // cl(string);

                    const amountSelectedFormats = this.selectedFormats.length;

                    goToPath = (this.basePath ? '/' + this.basePath : '') + (amountSelectedFormats == 1 ? '/' + this.selectedFormats[0].alias : '') + '#' + btoa(string);
                }

                if (goToPath != this.$route.fullPath) {
                    await router.push(goToPath);

                    if (fetchData) {
                        this.fetchData(1);
                    }
                }

                this.watchRoute = true;
                // console.log('goToPath end: ' + this.selection.length);

            },
            resetFilter() {
                this.search = '';
                this.searchTags = [];
                this.selectedGenres = [];
                this.selectedTempos = [];
                this.selectedFormats = [];
            },
            jingleInSelection(jingle) {
                let found = false;

                for (let s in this.selection) {
                    if (this.selection[s].id == jingle.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            jingleExpanded(jingle) {
                return this.expandedJingles.includes(jingle.id);
            },
            toggleJingleExpand(jingle) {
                let foundIndex = null;

                for (let e in this.expandedJingles) {
                    if (this.expandedJingles[e] == jingle.id) {
                        foundIndex = e;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.expandedJingles.push(jingle.id);
                } else {
                    this.expandedJingles.splice(foundIndex, 1);
                }
            },
            toggleSelectionItem(id) {
                // console.log('selecting start' + this.selection.length);
                var oldSelectionLength = this.selection.length;
                axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/jinglebox/update-selection', {
                        toggleId: id,
                        showForceGeoFields: this.showForceGeoFields,
                    })
                    .then((response) => {
                        if (response.data.hasOwnProperty('selection')) {
                            this.selection = response.data.selection;
                            // console.log('trigger goToPath')
                            this.goToPath(false);

                            if (this.selection.length < oldSelectionLength) {
                                this.$root.$emit('playerStarts', null, this);
                            }

                            this.$root.$emit('jingleboxCount', this.selection.length);
                        }
                    });
                // console.log('selection end: ' + this.selection.length);
            },
            removeAllSelectionItems() {
                this.$root.$emit('playerStarts', null, this);
                axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/jinglebox/update-selection', {reset: true})
                    .then((response) => {
                        if (response.data.hasOwnProperty('selection')) {
                            this.selection = response.data.selection;
                            this.goToPath(false);
                            this.$root.$emit('jingleboxCount', this.selection.length);
                        }
                    });
            },
            toggleGenre(genre) {
                let foundIndex = null;

                for (let g in this.selectedGenres) {
                    if (this.selectedGenres[g].id == genre.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedGenres.push(_.clone(genre));

                    _gte('jinglebox_genre', {
                        'event_category': document.title,
                        'event_label': 'select - ' + genre.name,
                    });

                } else {
                    this.selectedGenres.splice(foundIndex, 1);

                    _gte('jinglebox_genre', {
                        'event_category': document.title,
                        'event_label': 'deselect - ' + genre.name,
                    });
                }
            },
            isGenreActive(genre) {
                let found = false;

                for (let g in this.selectedGenres) {
                    if (this.selectedGenres[g].id == genre.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            toggleTempo(tempo) {
                let foundIndex = null;

                for (let g in this.selectedTempos) {
                    if (this.selectedTempos[g].id == tempo.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedTempos.push(_.clone(tempo));

                    _gte('jinglebox_tempo', {
                        'event_category': document.title,
                        'event_label': 'select - ' + tempo.name,
                    });
                } else {
                    this.selectedTempos.splice(foundIndex, 1);

                    _gte('jinglebox_tempo', {
                        'event_category': document.title,
                        'event_label': 'deselect - ' + tempo.name,
                    });
                }
            },
            isTempoActive(tempo) {
                let found = false;

                for (let g in this.selectedTempos) {
                    if (this.selectedTempos[g].id == tempo.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            toggleFormat(format) {
                let foundIndex = null;

                for (let g in this.selectedFormats) {
                    if (this.selectedFormats[g].id == format.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedFormats.push(_.clone(format));

                    _gte('jinglebox_format', {
                        'event_category': document.title,
                        'event_label': 'select - ' + format.name,
                    });
                } else {
                    this.selectedFormats.splice(foundIndex, 1);

                    _gte('jinglebox_format', {
                        'event_category': document.title,
                        'event_label': 'deselect - ' + format.name,
                    });
                }
            },
            isFormatActive(format) {
                let found = false;

                for (let g in this.selectedFormats) {
                    if (this.selectedFormats[g].id == format.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            toggleFilterMobile() {
            	this.filterMobileVisible = !this.filterMobileVisible;
            },
            toggleSort(sortKey) {
                //if sort key is same, toggle sort direction instead
                if (this.sort == sortKey) {
                    //if sort direction is ascending, switch to descending
                    if (this.sortDirection == 'asc') {
                        this.sortDirection = 'desc';

                        //if sort direction is descending, reset sort
                    } else if(this.sortDirection == 'desc') {
                        this.sortDirection = 'asc';
                        this.sort = null;
                    }

                    //if sort key is not the same, set sort and sortDirection to ascending
                } else {
                    this.sort = sortKey;
                    this.sortDirection = 'asc';
                }
            },
            getColumnHeaderClasses(key) {
                let classes = [];

                if(this.sort == key) {
                    classes.push('sort-' + (this.sortDirection == 'asc' ? 'asc' : 'desc'));
                }

                return classes;
            },
            goToPrevPage() {
                if (this.currentPage > 1) {
                    this.fetchData(this.currentPage - 1);
                    this.scrollNextPage();
                }
            },
            goToNextPage() {
                if (this.currentPage < this.totalPages) {
                    this.fetchData(this.currentPage + 1);
                    this.scrollNextPage();
                }
            },
            scrollNextPage() {
                var offset;

                if (window.innerWidth <= 500) {
                    offset = 150;
                }
                else if (window.innerWidth > 500 && window.innerWidth <= 1500) {
                    offset = 200;
                }
                else {
                    offset = 250
                }

                const y = this.$refs.sounds.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({top: y, behavior: 'smooth'});
            },
            async fetchData(page) {

                const usePath = location.hash.replace('#','');

                let extraPath = this.$route.path.replace(/^\/|\/$/g, '');

                if (this.basePath) {
                    extraPath = extraPath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                }

                const postData = {
                    initialized: this.initialized,
                    requestPath: this.requestPath,
                    itemsPerPage: this.itemsPerPage,
                    path: usePath,
                    extraPath: extraPath,

                    forceGeoLocationId: this.selectedGeoLocation,
                };

                if (this.initialized) {
                    postData.page = page;
                }

                if (this.$route.query['jinglebox-order-complete']) {
                    postData['jinglebox-order-complete'] = this.$route.query['jinglebox-order-complete'];
                }

                this.$root.$emit('playerStarts', null, this);

                await axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/jinglebox/search', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('searchTags')) {
                            this.searchTags = response.data.searchTags;
                        }
                        if (response.data.hasOwnProperty('genres')) {
                            this.genres = response.data.genres;

                            this.selectedFilter = 'genre';
                        }
                        if (response.data.hasOwnProperty('tempos')) {
                            this.tempos = response.data.tempos;

                            if (this.selectedFilter === null) {
                            this.selectedFilter = 'tempo';
                            }
                        }
                        if (response.data.hasOwnProperty('formats')) {
                            this.formats = response.data.formats;

                            if (this.selectedFilter === null) {
                            this.selectedFilter = 'format';
                            }
                        }
                        if (response.data.hasOwnProperty('selectedGenres')) {
                            this.selectedGenres = response.data.selectedGenres;
                        }
                        if (response.data.hasOwnProperty('selectedTempos')) {
                            this.selectedTempos = response.data.selectedTempos;
                        }
                        if (response.data.hasOwnProperty('selectedTempos')) {
                            this.selectedFormats = response.data.selectedFormats;
                        }
                        if (response.data.hasOwnProperty('selection')) {
                            this.selection = response.data.selection;
                        }
                        if (response.data.hasOwnProperty('results')) {
                            this.results = response.data.results;
                        }
                        if (response.data.hasOwnProperty('totalItems')) {
                            this.totalItems = response.data.totalItems;
                        }
                        if (response.data.hasOwnProperty('totalPages')) {
                            this.totalPages = response.data.totalPages;
                        }
                        if (response.data.hasOwnProperty('currentPage')) {
                            this.currentPage = response.data.currentPage;
                        }
                        if (response.data.hasOwnProperty('sort')) {
                            this.sort = response.data.sort;
                        }
                        if (response.data.hasOwnProperty('sortDirection')) {
                            this.sortDirection = response.data.sortDirection;
                        }

                        if (response.data.hasOwnProperty('path')) {
                            let usePath = this.$route.path.replace(/^\/|\/$/g, '');

                            if (this.basePath) {
                                usePath = usePath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                            }
                            if (usePath != response.data.path) {
                                router.push((this.basePath ? '/' + this.basePath : '') + '/' + response.data.path);
                            }
                        }
                        if (response.data.hasOwnProperty('orderId')) {
                            this.completedOrderId = response.data.orderId;
                        }
                    })
                    .catch(() => {

                    });
                this.expandedJingles = [];
                this.initialized = true;
                this.requestPath = false;
            },
            validateEmail(value) {
               return /\S+@\S+\.\S+/.test(value);
            },
            downloadOrderZip() {
                if (!this.completedOrderId) {
                    return false;
                }

                document.location = '/jinglebox/download/' + this.completedOrderId;
            }
        },
        computed: {
            watchValue() {
		      return `${this.searchTags}|${this.selectedGenres}|${this.selectedTempos}|${this.selectedFormats}|${this.sort}|${this.sortDirection}`;
            },
            nextStepAvailable() {
                if (this.checkoutStep == 1) {
                    if (this.checkoutData.first_name.trim() != '' && this.checkoutData.last_name.trim() != '' && this.checkoutData.email.trim() != '' && this.validateEmail(this.checkoutData.email)) {
                        return true;
                    }
                } else if (this.checkoutStep == 2) {
                    if (this.checkoutData.has_audio_logo != null) {
                        if (this.checkoutData.has_audio_logo) {
                            return this.checkoutData.audio_logo_is_free_of_rights != null;
                        }

                        return true;
                    }
                } else if (this.checkoutStep == 3) {
                    if (this.checkoutData.preferred_style.trim() != '' && this.checkoutData.preferred_vocals.trim() != '') {
                        return true;
                    }
                } else if (this.checkoutStep == 4) {
                    if (this.checkoutData.consent) {
                        return true;
                    }
                }

                return false;
            },
            maxStep() {
                return Math.max.apply(null,Object.keys(this.checkoutStepData));
            },
            genreLookup() {
                var lookup = {};

                for(var i in this.genres) {
                    var genre = this.genres[i];

                    lookup[genre.id] = genre;
                }

                return lookup;
            },
            formatLookup() {
                var lookup = {};

                for(var i in this.formats) {
                    var format = this.formats[i];

                    lookup[format.id] = format;
                }

                return lookup;
            },
        },
        mounted: async function() {
            this.$root.$on('toggleGenre', genreId => {
                var genre = this.genreLookup[genreId] || null;

                if (!genre) {
                    return false;
                }

                this.toggleGenre(genre);
            });
            this.$root.$on('toggleFormat', formatId => {
                var format = this.formatLookup[formatId] || null;

                if (!format) {
                    return false;
                }

                this.toggleFormat(format);
            });

            this.initCheckoutData();

            if (this.preSelectedFilter) {
                if (window.location.hash == '') {
                    await router.push((this.basePath ? '/' + this.basePath : '') + '#' + this.preSelectedFilter);
                }
            }

            await this.fetchData();

            // if (this.completedOrderId) {
            //     this.checkoutVisible = true;
            //     $html.addClass('modal-visible');
            //     this.downloadOrderZip();
            // }
        },
    }
</script>
